import type { FeatureCardContent } from "../content/types";
import { Icon } from "./Icon";

type FeatureCardProps = {
  card: FeatureCardContent;
};

export function FeatureCard({ card }: FeatureCardProps) {
  return (
    <article className="flex flex-col gap-4 rounded-3xl border border-subtle bg-bg-card p-7">
      <h3 className="font-display text-xl font-semibold text-text-primary">{card.title}</h3>
      <p className="text-sm leading-relaxed text-text-secondary">{card.body}</p>
      <ul className="mt-1 flex flex-col gap-2">
        {card.bullets.map((bullet) => (
          <li key={bullet} className="flex items-center gap-2 text-[13px] text-text-secondary">
            <Icon name="check" size={15} className="shrink-0 text-accent-cyan" />
            {bullet}
          </li>
        ))}
      </ul>
    </article>
  );
}
